import React, { useMemo } from "react";
import { Paper, makeStyles, Switch } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AllConditions from "./allConditions";

import styles from "./styles";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles(styles);

const DisplayPermissions = ({
  permissions,
  handleChange,
  recordType,
  changeInDefaultPermissions,
  handleChangeInRecordGlobal,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const actions = useMemo(
    () =>
      Object.keys(recordType.actions)
        .map((a) => recordType.actions[a])
        .filter((a) => !a.internal && !a.legacy),
    [recordType]
  );

  const handleChangeAllRecords = (event, recordType) => {
    event.persist();
    handleChangeInRecordGlobal(event.target.checked, recordType);
  };

  return (
    <TableContainer component={Paper} key={recordType.name}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerTop} align="center" colSpan="3">
              {recordType.label || recordType.name}
              <span className={classes.marginLeft}>
                <span className={classes.red}>
                  {t("labels.accessControl.rule.deny")}
                </span>
                <Switch
                  checked={
                    permissions &&
                    permissions[recordType.name].hasOwnProperty("*")
                      ? permissions[recordType.name]["*"]
                      : false
                  }
                  disableRipple
                  color="primary"
                  classes={{
                    switchBase: classes.switchBase,
                    thumb: classes.thumb,
                    track: classes.track,
                    checked: classes.checked,
                  }}
                  onChange={(event) =>
                    handleChangeAllRecords(event, recordType)
                  }
                />
                <span className={classes.green}>
                  {t("labels.accessControl.rule.allow")}
                </span>
              </span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.headerTop} align="left">
              {t("labels.accessControl.rule.table.headers.permission")}
            </TableCell>
            <TableCell className={classes.headerTop} align="center">
              {t("labels.accessControl.rule.table.headers.allowDeny")}
            </TableCell>
            <TableCell className={classes.headerTop} align="center">
              {t("labels.accessControl.rule.table.headers.conditions")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {actions.map((action) => {
            if (typeof permissions[recordType.name][action.name] === "string") {
              return;
            }
            return (
              <TableRow key={`${recordType.name}-${action.name}`}>
                <TableCell className={classes.rightBorder} width="30%">
                  {action.label || action.name}
                </TableCell>
                <TableCell
                  className={classes.rightBorder}
                  width="20%"
                  align="center"
                >
                  {
                    <>
                      <span className={classes.red}>
                        {t("labels.accessControl.rule.deny")}
                      </span>
                      <Switch
                        checked={
                          permissions[recordType.name][action.name][
                            "accessStatus"
                          ]
                        }
                        disableRipple
                        color="primary"
                        classes={{
                          switchBase: classes.switchBase,
                          thumb: classes.thumb,
                          track: classes.track,
                          checked: classes.checked,
                        }}
                        onChange={(event) =>
                          handleChange(
                            event,
                            "permissions",
                            action.name,
                            recordType.name
                          )
                        }
                      />
                      <span className={classes.green}>
                        {t("labels.accessControl.rule.allow")}
                      </span>
                    </>
                  }
                </TableCell>
                <TableCell align="center">
                  {permissions &&
                  permissions[recordType.name] &&
                  permissions[recordType.name][action.name] &&
                  permissions[recordType.name][action.name].accessStatus ===
                    true ? (
                    <AllConditions
                      conditions={
                        permissions[recordType.name][action.name]["conditions"]
                      }
                      updatePermissions={changeInDefaultPermissions}
                      recordTypeName={recordType.name}
                      actionName={action.name}
                    />
                  ) : (
                    t("labels.common.none")
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(DisplayPermissions);
